import { IPlanEnrollment } from "./types";

import { planEnrollmentService } from "./service";

export const getPlanEnrollment = async (
  planEnrollmentId: string
): Promise<IPlanEnrollment> => {
  const { data } = await planEnrollmentService.get(`/${planEnrollmentId}`);
  return data;
};
